import * as React from 'react';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './BarChart.module.scss';

type BarChartRow = {
    filter: (event: React.SyntheticEvent) => void;
    filterLink: string;
    leftLabel: React.ReactNode;
    percent: number;
    rightLabel: React.ReactNode;
};

type Props = {
    className?: string;
    fullPage: boolean;
    rightLabelStyles: string;
    rows: BarChartRow[];
};

const generateBars = (rows: BarChartRow[], fullPage: boolean, rightLabelStyles: string) => {
    const rightStyles = classNames(rightLabelStyles, styles.rightLabel);
    return rows.map<any>(({ filter, filterLink, leftLabel, percent, rightLabel }, index) => {
        return fullPage ? (
            <div className={styles.bar} key={index} onClick={filter}>
                <span className={styles.info}>{leftLabel}</span>
                <div className={styles.barContainer}>
                    <div className={styles.fullBar} style={{ width: `${percent}%` }} />
                </div>
                <span className={rightStyles}>{rightLabel}</span>
            </div>
        ) : (
            <Link className={styles.link} key={index} route to={filterLink}>
                <div className={styles.bar}>
                    <span className={styles.info}>{leftLabel}</span>
                    <div className={styles.barContainer}>
                        <div className={styles.fullBar} style={{ width: `${percent}%` }} />
                    </div>
                    <span className={rightStyles}>{rightLabel}</span>
                </div>
            </Link>
        );
    });
};

const BarChart = ({ className, fullPage, rightLabelStyles, rows }: Props) => {
    return (
        <div className={classNames(styles.barChart, className)}>
            {Array.isArray(rows) && generateBars(rows, fullPage, rightLabelStyles)}
        </div>
    );
};

export default React.memo<Props>(BarChart, isEqual);
